import { Wrapper, DateView } from "nystem-components";

const TripDuration = ({ view, model }) => {
  const { startTime, endTime } = view.value;
  if (!startTime || !endTime || endTime < startTime) return null;
  if (model.dateRange) {
    const sameYear = new Date(startTime).getFullYear() === new Date(endTime).getFullYear();
    return <Wrapper className={model.className}>
      {sameYear && <><DateView model={{ renderAs: "span", dateFormat: "year" }} value={startTime} /> · </>}
      <DateView model={{ renderAs: "span", dateFormat: sameYear ? "MM-DD" : "dateLong" }} value={startTime} />
      {" – "}
      <DateView model={{ renderAs: "span", dateFormat: sameYear ? "MM-DD" : "dateLong" }} value={endTime} />
    </Wrapper>;
  }
  const minutes = Math.floor((endTime - startTime) / 60000);
  const days = Math.floor(minutes / 1440);
  if (model.daysOnly) return <Wrapper className={model.className}>{days} {days === 1 ? "day" : "days"}</Wrapper>;
  const hours = Math.floor((minutes % 1440) / 60);
  return <Wrapper className={model.className}>{[
    days && `${days} ${days === 1 ? "day" : "days"}`,
    hours && `${hours} ${hours === 1 ? "hour" : "hours"}`,
    !model.hideMinutes && (minutes % 60 || !minutes) && `${minutes % 60} min`,
  ].filter((part) => part !== false && part !== 0).join(" ")}</Wrapper>;
};

export default TripDuration;
